














import { defineComponent } from "@vue/composition-api";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "ContentFeedUnlock",
  components: { BaseIcon },
  props: {
    size: { type: Number, required: true },
  },
});
